<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card title="Добавление показаний">
        <template v-if="apartments.length && !isApartmentsLoading">
          <div class="vx-row pb-4"  style="border-bottom: 1px solid rgba(0,0,0,0.2);">
            <div class="vx-col flex items-center justify-center w-full">
              <div style="width: 150px; min-width: 150px">
                <label for="newMetering-nextCheckingDate" class="vs-select--label w-full block text-center p-0">Месяц</label>
                <datepicker class="w-full" format="MMMM yyyy"
                            minimum-view="month"
                            maximum-view="year"
                            v-model="dateValue"
                            id="newMetering-nextCheckingDate"
                />
              </div>
            </div>
          </div>
          <div class="block lg:flex py-4 " style="border-bottom: 1px solid rgba(0,0,0,0.2);" v-for="(deviceValues, index) in devicesValues" :key="deviceValues.account_number + '-' + index">
            <div class="lg:mr-4">
              <vs-select label="Помещение"
                         class="mb-4 w-full lg:w-auto"
                         :autocomplete="true"
                         :value="deviceValues.account_number"
                         @input="changeAccountNumber(index, $event)"
              >
                <vs-select-item :key="apartment.id" :value="apartment.account_number"  :text="apartment.number + ' (' + apartment.account_number + ')'" v-for="apartment in apartments" />
              </vs-select>
            </div>
            <div class="lg:mr-4" v-for="(device, deviceIndex) in deviceValues.devices" :key="device.id + '-' + deviceIndex">
              <vs-input class="w-full"
                        type="number"
                        v-model="device.value"
                        :label="getDeviceTypesById(device.device_type) + '(' + (device.factory_number ? device.factory_number : 'Без номера') + ')'"
              />
            </div>
          </div>

          <div class="vx-row mt-6">
            <div class="vx-col w-full flex justify-center align-center flex-wrap">
              <vs-button type="border" @click="addMore" class="mr-2 mb-2">Добавить еще</vs-button>
              <vs-button @click="saveAll" color="success" class="mr-2 mb-2">Сохранить все</vs-button>
            </div>
          </div>


        </template>
        <div :class="{'activeLoading': isApartmentsLoading}"
             :id="`dataLoading-${_uid}`"
             ref="loadingContainer"
             class="vs-con-loading__container"
             style="height: 150px"
             v-show="isApartmentsLoading"
        >
        </div>

      </vx-card>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AddDevicesValues",
    data(){
      return {
        isApartmentsLoading: false,
        apartments: [],
        devices: {},
        dateValue: new Date(),
        devicesValues: [
          {
            account_number: null,
            devices: []
          }
        ],
      }
    },
    computed: {
      selectedHouseId(){
        return this.$store.getters['appUser/selectedHouse'].id
      }
    },
    methods: {
      async getAparts(){
        if(!this.$can('rp.worker.add_values', 'write')) return;
        this.isApartmentsLoading = true;
        try{
          let {data} = await this.$http.get(`all_aparts?buildings_id=${this.selectedHouseId}`);
          this.apartments = data.filter(apartment => apartment.account_number);
        }
        catch(e){
          this.apartments = [];
        }
        finally {
          this.$nextTick(() => {
            this.isApartmentsLoading = false;
          });

        }
      },
      getDevices(accountNumber){
        return new Promise(async resolve => {
          try{
            let {data} = await this.$http.get('device_with_values', {
              params: {
                account_number: accountNumber,
                buildings_id: this.selectedHouseId
              }
            });
            resolve(data);
          }
          catch(e){
            resolve([]);
          }
        });
      },
      getDeviceTypesById(id) {
        let deviceType = this.deviceTypes.find(deviceType => Number(deviceType.id) === Number(id));
        return deviceType ? deviceType.name : 'Неизвестное устройство';
      },
      async getDevicesTypes(){
        let {data} = await this.$http.get('devices_type');
        this.deviceTypes = data;
      },
      async changeAccountNumber(index, accountNumber){
        let devices = await this.getDevices(accountNumber);
        this.devicesValues[index].account_number = accountNumber;
        this.devicesValues[index].devices = [];
        devices.forEach(device => {
          this.devicesValues[index].devices.push({
            device_id: device.id,
            factory_number: device.factory_number,
            value: null,
            unit_id: null,
            device_type: device.type,
          });
        });
      },
      addMore(){
        let newDevicesValues = {
          account_number: null,
          devices: []
        };
        this.devicesValues.push(newDevicesValues);
      },
      async saveAll(){
        for await (let deviceValues of this.devicesValues) {
          if(deviceValues.account_number){
            for await (let deviceValue of deviceValues.devices) {
              if(String(deviceValue.value).trim().length &&!isNaN(String(deviceValue.value))){
                let body = Object.assign({}, deviceValue);
                body.account_number = deviceValues.account_number;
                body.date_value = this.$options.filters.formatDate(this.dateValue);
                body.value = Number(deviceValue.value);
                body.buildings_id = this.selectedHouseId;
                try{
                  let {data} = await this.$http.post('devices_value', body);

                  if (data === 'denied') {
                    this.$vs.notify({
                      color: 'danger',
                      title: 'Ошибка добавления',
                      text: `На ${this.$options.filters.moment(this.dateValue, 'MMMM YYYY')} уже показаны квитанции`
                    });
                  }
                }
                catch(e){
                  console.error(e);
                }
              }
            }
          }
        }
        this.devicesValues = [
          {
            account_number: null,
            devices: []
          }
        ];
        this.$vs.notify({color: 'success', title: 'Показания добавлены', text: 'Показания успешно добавлены'});
      }
    },
    mounted() {
      this.getAparts();
      this.getDevicesTypes();
    },
    watch:{
      isApartmentsLoading(){
       if(this.isApartmentsLoading){
         setTimeout(()=> this.$vs.loading({
           container: this.$refs.loadingContainer,
         }), 0);
       }
      },
      selectedHouseId(){
        this.getAparts();
        this.devicesValues = [
          {
            account_number: null,
            devices: []
          }
        ];
      }
    }
  }
</script>